<template>
    <div class="warpper padding-sm bg-white">
        <div class="flex align-center justify-between margin-bottom-sm ">
            <b class="page-title line-height">分会权限</b>
            <div class="flex align-center">
                <el-button class="publish" round type="primary" @click="submitPower">
                    保存
                </el-button>
                <el-button class="blue-btn" round type="primary" @click="$router.go(-1)"
                >返回
                </el-button>
            </div>
        </div>
        <div class="page-list flex flex-direction margin-top">
            <div v-for="(item,index) in powers" :key="index">
                <div v-if="!item.dis" class="item flex flex-direction margin-bottom-xs">
                    <div class="header flex align-center justify-between padding-lr-sm">
                        <div class="title"><i class="el-icon-menu"></i>{{ item.label }}</div>
                        <el-switch
                            v-model="item.isShow"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            @change="(e)=>{return changeClassify(e,index)}">
                        </el-switch>
                    </div>
                    <div v-for="(child,position) in item.childs" :key="position">
                        <div v-if="!child.dis"
                             class="child flex align-center justify-between">
                            <div class="title">{{ child.label }}</div>
                            <el-switch
                                v-model="child.isShow"
                                active-color="#13ce66"
                                inactive-color="#ff4949"
                                @change="(e)=>{return changeChild(e,index)}">
                            </el-switch>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {getFhPower, setFhPower} from "@/api/organiz";
import {powers} from "@/utils/const";

export default {
    name: "label",
    data() {
        return {
            id: '',
            powers: powers,
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    created() {
        this.$emit('setIndex', [8, 0], '分会权限')
        this.id = this.$route.params.id
        this.init()
    },
    components: {},
    methods: {
        //  页面加载时请求
        async init() {
            let _data = await getFhPower(this.id)
            if (_data.data) {
                let _power = _data.data.split(',')
                this.powers.map(item => {
                    item.isShow = _power.some(bol => bol === `${item.value}`)
                    if (item.childs) {
                        item.childs.map(child => {
                            child.isShow = _power.some(bol => bol === `${item.value}-${child.value}`)
                        })
                    }
                })
            }
        },
        changeClassify(e, index) {
            this.powers[index].childs.map(child => {
                child.isShow = e
            })
        },
        changeChild(e, index) {
            if (e){
                this.powers[index].isShow = e
            }else {
                this.powers[index].isShow = this.powers[index].childs.some(bol => bol.isShow)
            }
        },
        async submitPower() {
            let _power = []
            this.powers.map(item => {
                if (item.isShow) {
                    _power.push(`${item.value}`)
                }
                if (item.childs) {
                    item.childs.map(child => {
                        if (child.isShow) {
                            _power.push(`${item.value}-${child.value}`)
                        }
                    })
                }
            })
            let _data = await setFhPower(this.id, _power.join(','))
            if (_data.status === 200) {
                this.$message.success('保存成功')
            } else {
                this.$message.error(_data.msg)
            }
        },
    },
    filters: {},
    watch: {},
}
</script>

<style lang="scss" scoped>
.warpper {
    .page-list {
        .item {
            width: 100%;
            border: solid 1px #e8e8e8;

            .header {
                height: 68px;
                background-color: #f4f4f4;
                border-bottom: solid 1px #e8e8e8;

                .title {
                    font-size: 16px;
                    font-weight: bold;
                    color: #333333;

                    i {
                        font-size: 20px;
                        color: #0a2240;
                        margin-right: 10px;
                    }
                }
            }

            .child {
                height: 68px;
                background-color: #ffffff;
                padding: 0 28px;
                border-bottom: 1px solid #f6f6f6;

                .title {
                    font-size: 14px;
                    padding-left: 65px;
                    color: #333333;
                }
            }

            .sort {
                font-size: 14px;
                color: #0a2240;

                span {
                    background-color: #ffffff;
                    border-radius: 6px;
                    border: solid 1px #e8e8e8;
                    font-size: 14px;
                    color: #999999;
                    padding: 10px 15px;
                }
            }

            .operate {
                width: 60px;
                height: 34px;
                border-radius: 20px;
                border: solid 1px #0a2240;
                font-size: 14px;
                padding: 0;
                background-color: #0a2240;
                color: #ffffff;

                &.line {
                    background-color: #ffffff;
                    color: #0a2240;
                }

                &.active {
                    background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
                    linear-gradient(#29c16d, #29c16d);
                    background-blend-mode: normal, normal;
                    border: none;
                }
            }
        }
    }

    .input-container {
        .el-select {
            width: 100%;
        }
    }
}
</style>